/* ============================================
   HOME PAGE JAVASCRIPT
   ============================================ */

// Extended product data for home page
const homeProducts = [
    {
        id: 1,
        name: 'Wireless Bluetooth Headphones with Noise Cancellation',
        price: 1999,
        originalPrice: 3999,
        rating: 4.5,
        reviews: 1234,
        image: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=500&q=80',
        category: 'Electronics',
        brand: 'TechBrand',
        inStock: true
    },
    {
        id: 2,
        name: 'Smart Fitness Watch with Heart Rate Monitor',
        price: 2499,
        originalPrice: 4999,
        rating: 4.3,
        reviews: 856,
        image: 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=500&q=80',
        category: 'Electronics',
        brand: 'FitTech',
        inStock: true
    },
    {
        id: 3,
        name: 'Premium Cotton Casual Shirt - Slim Fit',
        price: 599,
        originalPrice: 1299,
        rating: 4.1,
        reviews: 432,
        image: 'https://images.unsplash.com/photo-1596755094514-f87e34085b2c?w=500&q=80',
        category: 'Fashion',
        brand: 'StyleCo',
        inStock: true
    },
    {
        id: 4,
        name: 'Running Shoes - Lightweight & Comfortable',
        price: 1799,
        originalPrice: 2999,
        rating: 4.6,
        reviews: 2341,
        image: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=500&q=80',
        category: 'Fashion',
        brand: 'SportMax',
        inStock: true
    },
    {
        id: 5,
        name: 'Laptop Backpack with USB Charging Port',
        price: 899,
        originalPrice: 1799,
        rating: 4.4,
        reviews: 567,
        image: 'https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=500&q=80',
        category: 'Accessories',
        brand: 'TravelPro',
        inStock: true
    },
    {
        id: 6,
        name: 'Wireless Optical Mouse - Ergonomic Design',
        price: 399,
        originalPrice: 799,
        rating: 4.2,
        reviews: 891,
        image: 'https://images.unsplash.com/photo-1527864550417-7fd91fc51a46?w=500&q=80',
        category: 'Electronics',
        brand: 'TechBrand',
        inStock: true
    },
    {
        id: 7,
        name: 'Stainless Steel Insulated Water Bottle 1L',
        price: 349,
        originalPrice: 699,
        rating: 4.5,
        reviews: 1123,
        image: 'https://images.unsplash.com/photo-1602143407151-0111419516eb?w=500&q=80',
        category: 'Home',
        brand: 'EcoLife',
        inStock: true
    },
    {
        id: 8,
        name: 'Premium Yoga Mat - Non-Slip Surface',
        price: 499,
        originalPrice: 999,
        rating: 4.3,
        reviews: 678,
        image: 'https://images.unsplash.com/photo-1601925260368-ae2f83cf8b7f?w=500&q=80',
        category: 'Sports',
        brand: 'FitLife',
        inStock: true
    },
    {
        id: 9,
        name: 'Portable Bluetooth Speaker - Waterproof',
        price: 1299,
        originalPrice: 2499,
        rating: 4.4,
        reviews: 945,
        image: 'https://images.unsplash.com/photo-1608043152269-423dbba4e7e1?w=500&q=80',
        category: 'Electronics',
        brand: 'SoundMax',
        inStock: true
    },
    {
        id: 10,
        name: 'Designer Sunglasses - UV Protection',
        price: 799,
        originalPrice: 1599,
        rating: 4.2,
        reviews: 523,
        image: 'https://images.unsplash.com/photo-1511499767150-a48a237f0083?w=500&q=80',
        category: 'Fashion',
        brand: 'StyleCo',
        inStock: true
    },
    {
        id: 11,
        name: 'Mechanical Gaming Keyboard - RGB Backlit',
        price: 2999,
        originalPrice: 4999,
        rating: 4.7,
        reviews: 1567,
        image: 'https://images.unsplash.com/photo-1587829741301-dc798b91a603?w=500&q=80',
        category: 'Electronics',
        brand: 'GameTech',
        inStock: true
    },
    {
        id: 12,
        name: 'Ceramic Coffee Mug Set - 6 Pieces',
        price: 449,
        originalPrice: 899,
        rating: 4.3,
        reviews: 234,
        image: 'https://images.unsplash.com/photo-1514228742587-6b1558fcca3d?w=500&q=80',
        category: 'Home',
        brand: 'HomeEssentials',
        inStock: true
    },
    {
        id: 13,
        name: 'Denim Jeans - Stretchable Fabric',
        price: 899,
        originalPrice: 1799,
        rating: 4.1,
        reviews: 678,
        image: 'https://images.unsplash.com/photo-1542272617-08f086302542?w=500&q=80',
        category: 'Fashion',
        brand: 'DenimCo',
        inStock: true
    },
    {
        id: 14,
        name: 'LED Desk Lamp - Adjustable Brightness',
        price: 599,
        originalPrice: 1199,
        rating: 4.4,
        reviews: 456,
        image: 'https://images.unsplash.com/photo-1534073828943-f801091a7d58?w=500&q=80',
        category: 'Home',
        brand: 'LightUp',
        inStock: true
    },
    {
        id: 15,
        name: 'Protein Shaker Bottle - 700ml',
        price: 249,
        originalPrice: 499,
        rating: 4.2,
        reviews: 789,
        image: 'https://images.unsplash.com/photo-1570183562479-7f88e4d209c7?w=500&q=80',
        category: 'Sports',
        brand: 'FitLife',
        inStock: true
    },
    {
        id: 16,
        name: 'Smartphone Stand - Adjustable Angle',
        price: 299,
        originalPrice: 599,
        rating: 4.0,
        reviews: 345,
        image: 'https://images.unsplash.com/photo-1586105251261-72a756497a11?w=500&q=80',
        category: 'Accessories',
        brand: 'TechBrand',
        inStock: true
    }
];

// Create product card HTML
const createProductCard = (product) => {
    const discount = window.ecommerce.calculateDiscount(product.originalPrice, product.price);
    const isWishlisted = window.ecommerce.isInWishlist(product.id);

    return `
    <div class="product-card" onclick="window.location.href='pages/product-detail.html?id=${product.id}'">
      <div class="discount-badge">${discount}% OFF</div>
      <button class="wishlist-toggle ${isWishlisted ? 'active' : ''}" 
              data-product='${JSON.stringify(product)}'
              onclick="event.stopPropagation()">
        <svg viewBox="0 0 24 24" fill="${isWishlisted ? 'currentColor' : 'none'}" stroke="currentColor" stroke-width="2">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
        </svg>
      </button>
      <img src="${product.image}" alt="${product.name}" class="product-card-image">
      <div class="product-card-body">
        <h3 class="product-card-title">${product.name}</h3>
        <div class="product-rating">
          <span class="rating-badge">
            ${product.rating} ★
          </span>
          <span class="rating-count">(${product.reviews.toLocaleString()})</span>
        </div>
        <div class="product-card-price">
          ${window.ecommerce.formatPrice(product.price)}
          <span class="product-card-original-price">${window.ecommerce.formatPrice(product.originalPrice)}</span>
          <span class="product-card-discount">${discount}% off</span>
        </div>
        <button class="btn btn-primary btn-sm btn-block quick-add-to-cart" 
                data-product='${JSON.stringify(product)}'
                onclick="event.stopPropagation()">
          Add to Cart
        </button>
      </div>
    </div>
  `;
};

// Populate product sections
const populateSection = (sectionId, products) => {
    const section = document.getElementById(sectionId);
    if (!section) return;

    section.innerHTML = products.map(product => createProductCard(product)).join('');
};

// Shuffle array helper
const shuffleArray = (array) => {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
};

// Get random products
const getRandomProducts = (count) => {
    return shuffleArray(homeProducts).slice(0, count);
};

// Get products by category
const getProductsByCategory = (category, count) => {
    const filtered = homeProducts.filter(p => p.category === category);
    return shuffleArray(filtered).slice(0, count);
};

// Get top rated products
const getTopRated = (count) => {
    return [...homeProducts]
        .sort((a, b) => b.rating - a.rating)
        .slice(0, count);
};

// Get products with best discounts
const getBestDiscounts = (count) => {
    return [...homeProducts]
        .sort((a, b) => {
            const discountA = window.ecommerce.calculateDiscount(a.originalPrice, a.price);
            const discountB = window.ecommerce.calculateDiscount(b.originalPrice, b.price);
            return discountB - discountA;
        })
        .slice(0, count);
};

// Initialize home page
const initHomePage = () => {
    // Populate Top Deals
    populateSection('top-deals', getRandomProducts(8));

    // Populate You May Also Like
    populateSection('you-may-like', getRandomProducts(8));

    // Populate Discounts for You
    populateSection('discounts', getBestDiscounts(8));

    // Populate Top Rated
    populateSection('top-rated', getTopRated(8));

    // Populate Fashion's Top Deals
    populateSection('fashion-deals', getProductsByCategory('Fashion', 8));

    // Populate Recently Viewed
    const recentlyViewed = window.ecommerce.getRecentlyViewed();
    if (recentlyViewed.length > 0) {
        populateSection('recently-viewed', recentlyViewed.slice(0, 8));
    } else {
        // Show random products if no recently viewed
        populateSection('recently-viewed', getRandomProducts(8));
    }
};

// Run on page load
document.addEventListener('DOMContentLoaded', () => {
    initHomePage();

    // Update wishlist button states
    document.addEventListener('click', (e) => {
        if (e.target.closest('.wishlist-toggle')) {
            const btn = e.target.closest('.wishlist-toggle');
            const svg = btn.querySelector('svg');

            if (btn.classList.contains('active')) {
                svg.setAttribute('fill', 'currentColor');
            } else {
                svg.setAttribute('fill', 'none');
            }
        }
    });
});
